/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCircularProgress1 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m18.364 6.636 1.414-1.414A10.965 10.965 0 0 0 12 2v2a8.976 8.976 0 0 1 6.364 2.636"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCircularProgress1 as CircularProgress1 };
